import types from "./types";

export function changeLayout(index) {
  return {
    type: types.CHANGE_LAYOUT,
    payload: { index }
  }
}

export function setValue(id, value) {
  return {
    type: types.SET_VALUE,
    payload: { id, value }
  }
}

export function setFontSize(id, value) {
  return {
    type: types.SET_FONT_SIZE,
    payload: { id, value }
  }
}

export function setImage(file, previewUrl) {
  return {
    type: types.SET_IMAGE,
    payload: { file, previewUrl }
  }
}

export function setBackupImage(url) {
  return {
    type: types.SET_BACKUP_IMAGE,
    payload: { url }
  }
}

export function changeAmount(amount, price) {
  return {
    type: types.CHANGE_AMOUNT,
    payload: { amount, price }
  }
}